import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'finder-pricing-grid',
    templateUrl: './pricing-grid.component.html',
    styleUrls: ['./pricing-grid.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ComponentHeaderComponent,
        SafeHtmlPipe,
    ]
})
export class PricingGridComponent implements AfterViewInit {
    @Input() data: any;

    detailSelected = '';

    constructor() { }

    ngAfterViewInit(): void {
        if (!this.data) {
            return;
        }

        // Pull out the first category
        this.updatePricing(this.data.titles[0]?.priceDetail);
    }

    updatePricing(priceDetail: string = '') {
        this.detailSelected = priceDetail;
    }
}
